import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Leaf, ArrowUpRight } from "lucide-react";
import { useAuth } from "@/components/AuthProvider";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, loading } = useAuth();

  useEffect(() => {
    document.title = "Redaktions-Login – Grüne Geldanlage";
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-brand-paper flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <div className="flex items-center gap-3 mb-8">
          <span className="inline-flex items-center justify-center w-10 h-10 bg-brand-primary text-white">
            <Leaf strokeWidth={1.5} size={20} />
          </span>
          <span className="font-serif text-2xl">Grüne Geldanlage</span>
        </div>
        <div className="border border-neutral-200 bg-white p-10">
          <div className="overline mb-3">Redaktion</div>
          <h1 className="font-serif text-3xl mb-3">Anmelden</h1>
          <p className="text-neutral-600 mb-8">Zugang zum Redaktions-Backend über Google-Login. Nur autorisierte Redaktionsmitglieder haben Zugriff.</p>
          {location.state?.error && (
            <div className="mb-4 p-3 border border-destructive/30 text-destructive text-sm">{location.state.error}</div>
          )}
          <Button onClick={handleLogin} className="w-full bg-brand-primary hover:bg-brand-hover text-white h-11 rounded-none" data-testid="google-login-btn">
            Mit Google anmelden <ArrowUpRight size={16} className="ml-2" />
          </Button>
          <p className="text-xs text-neutral-500 mt-6">Durch die Anmeldung werden die notwendigen Session-Cookies gesetzt.</p>
        </div>
      </div>
    </div>
  );
}
